import React from "react";
export default function Header(){
    return (
        <header className="bg-black">
            <h1 className="text-white m-0 mb-2 p-5">Meme Generator</h1>
        </header>
    )
}